export default "__VITE_ASSET__79JNLNXf__"